/* HDN · Carrusel sencillo de las piezas propias (marcas de la portada).
 *
 * El desplazamiento es el scroll nativo del navegador con scroll-snap: en móvil se
 * arrastra con el dedo como cualquier lista de una app. Este código solo mueve las
 * flechas: pasan de página, se apagan en los extremos y se esconden si todo cabe sin
 * desplazar (atributo data-overflow en <hdn-carrusel>).
 */
(function () {
  if (customElements.get('hdn-carrusel')) return;

  class HdnCarrusel extends HTMLElement {
    connectedCallback() {
      this.pista = this.querySelector('[data-track]');
      if (!this.pista) return;
      this.anterior = this.querySelector('[data-prev]');
      this.siguiente = this.querySelector('[data-next]');
      this.abort = new AbortController();

      const opciones = { signal: this.abort.signal };
      this.anterior?.addEventListener('click', () => this.pagina(-1), opciones);
      this.siguiente?.addEventListener('click', () => this.pagina(1), opciones);
      this.pista.addEventListener('scroll', () => this.encola(), { passive: true, signal: this.abort.signal });

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.encola());
        this.ro.observe(this.pista);
      } else {
        window.addEventListener('resize', () => this.encola(), opciones);
      }
      this.actualiza();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.ro?.disconnect();
      cancelAnimationFrame(this.raf);
    }

    pagina(direccion) {
      const pista = this.pista;
      const primero = pista.firstElementChild;
      const hueco = parseFloat(getComputedStyle(pista).columnGap) || 0;
      const paso = primero ? primero.getBoundingClientRect().width + hueco : pista.clientWidth;
      const porPagina = Math.max(1, Math.floor((pista.clientWidth + hueco) / paso));
      const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const sentido = getComputedStyle(pista).direction === 'rtl' ? -1 : 1;
      pista.scrollBy({ left: sentido * direccion * porPagina * paso, behavior: reducido ? 'auto' : 'smooth' });
    }

    encola() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = 0;
        this.actualiza();
      });
    }

    actualiza() {
      const pista = this.pista;
      const maximo = pista.scrollWidth - pista.clientWidth;
      const desborda = maximo > 2;
      const posicion = Math.abs(pista.scrollLeft);
      this.toggleAttribute('data-overflow', desborda);
      if (this.anterior) this.anterior.disabled = !desborda || posicion <= 2;
      if (this.siguiente) this.siguiente.disabled = !desborda || posicion >= maximo - 2;
    }
  }

  customElements.define('hdn-carrusel', HdnCarrusel);
})();
